export const GASearch = (search) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "search",
    search_term: search,
  });
};
